export interface ClientData {
  contactInfo: {
    primaryEmailAddress: string;
    preferredName?: string;
  };
  birthDate: string;
  citizenship: string;
  firstName: string;
  middleName: string;
  lastName: string;
  tin_private: string;
  phoneNumber: string;
  isMobile: boolean;
  incapacitated: boolean;
  gender: string;
  // Organization-specific fields
  isOrganizationUser?: boolean;
  organizationName?: string;
  incorporationDate?: string;
  organizationType?: string;
}

export interface ClientSegment {
  segmentTypeCode: string;
  digitalAdviseService: boolean;
  savings529BeneficiaryOnly?: boolean; //post graphql
  smallMarket401kAccountOnly?: boolean; //post graphql
  ugmaUtmaAdultOnly?: boolean; //post graphql
}
